import PropTypes from "prop-types";
import React from "react";
import { FormLabel } from "@mui/material";

import TextInput from "../../../ui/TextInput";

export default function AadtInputGroup({
  defaultValues,
  errors,
  formData,
  groups,
  register,
}) {
  return (
    <div style={{ display: "flex" }}>
      {groups.map(({ id, label }) => {
        const aadtProps = {
          errors,
          isRequired: true,
          register,
          min: 0,
          max: 100000,
          sx: { marginTop: "15px" },
          type: "number",
        };
        return (
          <div
            key={id}
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "40px",
              marginBottom: "40px",
              marginTop: "20px",
            }}
          >
            <FormLabel>{label}</FormLabel>
            <TextInput
              currentValue={formData[id]?.openingYearAADT ?? 0}
              defaultValue={defaultValues[id]?.openingYearAADT}
              label="Opening Year AADT"
              name={`${id}.openingYearAADT`}
              {...aadtProps}
            />
            <TextInput
              currentValue={formData[id]?.designYearAADT ?? 0}
              defaultValue={defaultValues[id]?.designYearAADT}
              label="Design Year AADT"
              name={`${id}.designYearAADT`}
              {...aadtProps}
            />
          </div>
        );
      })}
    </div>
  );
}

AadtInputGroup.propTypes = {
  defaultValues: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  register: PropTypes.func.isRequired,
};
